import { Typography, Skeleton } from "@mui/material";
import { styled } from "@mui/system";
import theme from "../../styles/styleTheme";

type FieldProps = {
  property: any;
  label: string;
  value: any;
  skeletonWidth: number;
  border: boolean;
};

type styledProps = {
  styledBorder: boolean;
};

const PropertyDetailsSpecificationsField = ({
  property,
  label,
  value,
  skeletonWidth,
  border,
}: FieldProps) => {
  if (!value) {
    return null;
  }
  return (
    <ListItem styledBorder={border}>
      <Label>{label}</Label>
      <Value>
        {property ? value : <Skeleton variant="text" width={skeletonWidth} />}
      </Value>
    </ListItem>
  );
};

const ListItem = styled("li")<styledProps>(({ styledBorder }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  listStyleType: "none",
  gap: 10,
  borderTop: styledBorder ? "1px solid #eee" : "none",
  padding: "10px 0",
}));

const Label = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
  color: theme.palette.text.secondary,
});

const Value = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
  textAlign: "right",
  color: "black",
});

export default PropertyDetailsSpecificationsField;
